$(window).on("load", function(){
  if($(".slider_wrap").length > 0) {
$('.slider_wrap').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 2,
        arrows: true,
  
    variableWidth: true,
    
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              arrows: false
            }
          },
          {
            breakpoint: 680,
            settings: {
              slidesToShow: 1 ,
              arrows: false
              
            }
          } 
        ]
      });
  }
    });
    



mobileOnlySlider(".home_three_text_box.slider_on_mobile .thtxt_flx, .multicolumn.background-primary.multicolumn_mob_slider .multicolumn-list, .multicolumn.multicolumn_slider ul.multicolumn-list", false, true, 767);
function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
	var slider = $($slidername);
	var settings = {
		mobileFirst: true,
		dots: $dots,
		arrows: $arrows,
		responsive: [
			{
				breakpoint: $breakpoint,
				settings: "unslick"
			}
		]
	};

	slider.slick(settings);

	$(window).on("resize", function () {
		if ($(window).width() > $breakpoint) {
			return;
		}
		if (!slider.hasClass("slick-initialized")) {
			return slider.slick(settings);
		}
	});
}


  $(document).ready(function(){
  $('.side_menu .side_nav li a.active').click(function(e) {
    e.preventDefault();
    
    $('.side_menu ul.side_nav li').children("a").show();   
});
});
